import { Box, Stack, Typography, Tooltip } from '@mui/material'
import { C1ToggleButtons } from 'components/core/RHKFormComponents/C1ToggleButtons'
import { ButtonOption } from 'components/pages/dynamic_groups/detail/expression-builder/RadioButtonButtonGroup'
import { FC } from 'react'
import { useForm } from 'react-hook-form'

type ToggleViewButtonOption = ButtonOption & {
    view: React.ReactElement
    disabled?: boolean
}

type ToggleViewButtonsProps = {
    onChange: (value: string) => void
    value: string
    options: ToggleViewButtonOption[]
    label?: React.ReactNode
    disabled?: boolean
    tooltip?: React.ReactElement | string
    'aria-label'?: string
}

type FormData = {
    toggleValue: string
}

export const ToggleViewButtons: FC<ToggleViewButtonsProps> = ({ onChange, label, options, value, tooltip, disabled, 'aria-label': ariaLabel }) => {
    const { control } = useForm<FormData>({
        defaultValues: {
            toggleValue: value,
        },
        values: {
            toggleValue: value,
        },
    })

    const group = <C1ToggleButtons
        control={control}
        name="toggleValue"
        options={options.map((opt) => ({
            value: opt.value,
            children: opt.label,
            disabled: opt.disabled,
        }))}
        onChange={(newValue): void => onChange(newValue as string)}
        aria-label={ariaLabel}
        disabled={disabled}
    />

    return <>
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
            <Typography variant="h6" component="div">{label}</Typography>

            <Stack direction="row" spacing={1} alignItems="center">
                {tooltip
                    ? <Tooltip
                        title={tooltip}
                        placement="top"
                    >
                        <Box>
                            {group}
                        </Box>
                    </Tooltip>
                    : group
                }
            </Stack>
        </Stack>

        {options.map((option) => option.value === value && (
            <Box key={option.value}>
                {option.view}
            </Box>
        ))}
    </>
}
